import { render, staticRenderFns } from "./TechCoop.vue?vue&type=template&id=0c9d4a73&"
import script from "./TechCoop.vue?vue&type=script&setup=true&lang=js&"
export * from "./TechCoop.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports